import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';

export class MicrobiologyBuildPart extends BaseBuildPart {
    constructor(private readonly microbiologyHelperParams: HelperParams,
                parent: BaseBuildPart) {
        super(microbiologyHelperParams, parent, ['microbiology-data']);
    }

    public isolateCultureData() {
        return new BaseBuildPart(this.microbiologyHelperParams, this, ['isolate-culture-data']);
    }
}